/**
 * # Homepage FAQ
 */

/**
 * ## Imports
 */
import './HomepageFaq.scss';

import { useTranslation } from 'react-i18next';

import './utils/AccordionAnimation';
import AccordionAnimation from './utils/AccordionAnimation';
import AccordionOnlyOneDetail from './utils/AccordionOnlyOneDetail';

/**
 * Component
 * @param {string} id
 * @param {object} questionCatalog
 * @param {boolean} withOwnBackground
 * @returns React
 */
const HomepageFaq = ({
    id,
    questionCatalog,
    withOwnBackground = true,
    withHeadline = true,
    withCenterwrapper = true,
}) => {
    const { t } = useTranslation('websiteV2');

    AccordionOnlyOneDetail();

    document.querySelectorAll('.homepage-faq__details').forEach((el) => {
        new AccordionAnimation(el);
    });

    return (
        <section className={`homepage-faq${!withOwnBackground ? ' homepage-faq--no-background' : ''}`} id={id}>
            <div className={`homepage-faq__body${withCenterwrapper ? ' home-centerwrapper-wide' : ''}`}>
                {withHeadline && (
                    <h2 className="homepage-headline-big homepage-faq__headline">
                        <span className="headline-sober">{t('questions-title-1', 'Questions?')}</span>
                        <br />
                        {t('questions-title-2', 'We have answers.')}
                    </h2>
                )}

                <div className="homepage-faq__accordion">
                    {questionCatalog.map((question) => (
                        <details className="homepage-faq__details" key={question.id}>
                            <summary className="homepage-faq__summary">{t(question.question)}</summary>
                            <div
                                className="homepage-faq__answer"
                                dangerouslySetInnerHTML={{ __html: t(question.answer, { url: question.link }) }}
                            />
                            {/* TODO this answer changes 4th time actually. Commenting in case if will back to this listed answers */}
                            {/* {question.listedAnswers?.length > 0 ?
                                    question.listedAnswers?.map((answer, i) => {
                                        return (
                                            <div key={i} className="homepage-faq__answer" dangerouslySetInnerHTML={{__html: t(answer, { url: question.link })}} />
                                        )
                                    }) :
                                    <div className="homepage-faq__answer" dangerouslySetInnerHTML={{__html: t(question.answer, { url: question.link })}} />
                                } */}
                        </details>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HomepageFaq;
